import SecureLS from 'secure-ls';

const SECRET_KEY = process.env.LOCAL_STORAGE_HELPER_SECRET_KEY;
class LocalStorageHelper {
    constructor() {
        this.ls = new SecureLS({ encodingType: 'aes', isCompression: false, encryptionSecret: SECRET_KEY });
    }

    // Veri kaydetme
    setItem(key, value) {
        try {
            this.ls.set(key, value);
        } catch (error) {
            console.error(`Failed to store item "${key}": `, error);
        }
    }

    // Veri okuma
    getItem(key) {
        try {
            return this.ls.get(key);
        } catch (error) {
            console.error(`Failed to retrieve item "${key}": `, error);
            return null;
        }
    }

    // Veri silme
    removeItem(key) {
        try {
            this.ls.remove(key);
        } catch (error) {
            console.error(`Failed to remove item "${key}": `, error);
        }
    }

    // Tüm verileri temizleme
    clearAll() {
        try {
            this.ls.clear();
        } catch (error) {
            console.error("Failed to clear items: ", error);
        }
    }
}

export default new LocalStorageHelper();